import { render, staticRenderFns } from "./singlereportlist.vue?vue&type=template&id=48a146f7&scoped=true"
import script from "./singlereportlist.vue?vue&type=script&lang=js"
export * from "./singlereportlist.vue?vue&type=script&lang=js"
import style0 from "./singlereportlist.vue?vue&type=style&index=0&id=48a146f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a146f7",
  null
  
)

export default component.exports